export const STEPS = {
  1: "1_GENERAL_INFORMATION",
  2: "2_BUSINESS_DATA",
  3: "3_PRODUCTS",
  4: "4_COMPLETED",
};

export const TOTAL_STEPS = 3;
export const COMPLETED_STEP = 4;
